function initPageform() {

    try {
        const field_group = document.querySelector('.fieldgroup.js-expand');
        const expander = field_group.querySelector('.middleColumn.fieldgroup');
        const label = field_group.querySelector('label.left');

        label.classList.add("toggle-label"); // To have a unique class for the label

        expander.classList.toggle("hide");


        label.addEventListener("click", function () {
            expander.classList.toggle("hide");

            if (expander.classList.contains("hide")) {
                label.innerHTML = "+ Tilføj kommentar"
            }
            else {
                label.innerHTML = "- Fjern kommentar"
            }
        });
    } catch (error) {
        //console.error(error);
    }
}

export default initPageform;
